import React from 'react';
import classnames from 'classnames';
import formatMoney from 'utils/formatters/Money';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';

class PaymentSummary extends React.Component {
  render() {
    const { total, paid, balance, credit_memos, t, currency } = this.props;
    return (
      (<div
        data-testid="div-cbeffac4"
        className="border-b border-r border-gray-200 border-solid">
        <dl
          data-testid="dl-3676a8cc"
          className="text-left divide-y divide-gray-200 divide-solid">
          <div
            data-testid="div-08881ea2"
            className="px-4 py-4 sm:px-6 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt data-testid="dt-ab055e7a" className="text-sm font-medium text-gray-500">{titleize(t('TOTAL'))}</dt>
            <dd data-testid="dd-4971e29e" className="">{formatMoney(total, currency)}</dd>
          </div>
          <div
            data-testid="div-61f0cb65"
            className="px-4 py-4 sm:px-6 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt data-testid="dt-aff0cca7" className="text-sm font-medium text-gray-500">{titleize(t('PAID'))}</dt>
            <dd data-testid="dd-d33b7569" className="">{formatMoney(paid, currency)}</dd>
          </div>
          {credit_memos && (
            <div
              data-testid="div-2c34c100"
              className="px-4 py-4 sm:px-6 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt data-testid="dt-8c2663fe" className="text-sm font-medium text-gray-500">{titleize(t('CREDIT'))}</dt>
              <dd
                data-testid="dd-f1f60704"
                className={classnames({
                  'text-red-500': !!credit_memos?.length,
                })}>
                {formatMoney(
                  (credit_memos &&
                    credit_memos.length &&
                    credit_memos[0]?.total) ||
                    0, currency
                )}
              </dd>
            </div>
          )}
          <div
            data-testid="div-9e0901a3"
            className="px-4 py-4 sm:px-6 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
            <dt data-testid="dt-b76578e8" className="text-sm font-medium text-gray-500">{titleize(t('BALANCE'))}</dt>
            <dd data-testid="dd-199f4f4e" className="">{formatMoney(balance, currency)}</dd>
          </div>
          {credit_memos && (
            <div
              data-testid="div-30cd88a1"
              className="px-4 py-4 sm:px-6 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4">
              <dt data-testid="dt-dc312cb3" className="text-sm font-medium text-gray-500">{t('CREDIT_MEMO')}</dt>
              <dd data-testid="dd-075de389" className="">
                {credit_memos &&
                  !!credit_memos.length &&
                  credit_memos.reduce((result, creditMemo, index) => {
                    return (<>
                      {result} {credit_memos.length > index + 1 ? ', ' : ''}
                      <a
                        data-testid="a-db029a21"
                        href={`/invoices/${creditMemo._id}`}
                        target="_blank"
                        rel="noreferrer">
                        {creditMemo.number}
                      </a>
                    </>);
                  }, null)}
              </dd>
            </div>
          )}
        </dl>
      </div>)
    );
  }
}

export default withTranslation()(PaymentSummary);
